import { useEffect, useState } from 'react';
import { useSonaxWidget } from './useSonaxWidget';

interface UseSonaxWithAppStateProps {
  canLoadSonax: boolean;
  appFullyLoaded: boolean;
  session: any;
}

export const useSonaxWithAppState = ({ 
  canLoadSonax, 
  appFullyLoaded, 
  session 
}: UseSonaxWithAppStateProps) => {
  const [sonaxReady, setSonaxReady] = useState(false);
  
  // Determina se o Sonax pode ser carregado
  const canLoad = canLoadSonax && appFullyLoaded && session && sonaxReady;
  
  const sonaxWidget = useSonaxWidget({ canLoad });

  useEffect(() => {
    // Só permite carregar o Sonax quando:
    // 1. A aplicação estiver totalmente carregada
    // 2. O flag canLoadSonax estiver true
    // 3. O usuário estiver autenticado
    if (canLoadSonax && appFullyLoaded && session && !sonaxReady) {
      // Pequeno delay para garantir que a aplicação esteja completamente renderizada
      const timer = setTimeout(() => {
        setSonaxReady(true);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [canLoadSonax, appFullyLoaded, session, sonaxReady]);

  // Reset do estado quando a sessão mudar
  useEffect(() => {
    if (!session) {
      setSonaxReady(false);
    }
  }, [session]);

  return {
    ...sonaxWidget,
    sonaxReady,
    canLoadSonax: canLoad
  };
};
